import { renderVerificationStatus } from "@utils/clinic";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { type Column, Heading, Paragraph, Table } from "@fronterahealth/frontera-ui-components";

import {
  BasecampClinicListingsRetrieveVerificationStatus,
  type GetClinicListingsOutput,
  VerificationStatusEnum,
  useBasecampClinicListingsRetrieve,
} from "@api/rest/types-and-hooks";

const COLUMNS: Column<GetClinicListingsOutput>[] = [
  {
    title: "Clinic name",
    dataIndex: "name",
    key: "name",
    render: (value) => (
      <Paragraph size="small" colorType="secondary">
        {(value as string) ?? "—"}
      </Paragraph>
    ),
  },
  {
    title: "Organization",
    dataIndex: "claimed_by",
    key: "organization",
    render: (value) => (
      <Paragraph size="small" displayType="loud" colorType="primary">
        {(value as GetClinicListingsOutput["claimed_by"])?.organization.name ?? "—"}
      </Paragraph>
    ),
  },
  {
    title: "Created",
    dataIndex: "created_date",
    key: "created_date",
    render: (value) => (
      <Paragraph size="small" colorType="secondary">
        {value ? format(new Date(value as string), "MMM dd yyyy") : "—"}
      </Paragraph>
    ),
  },
  {
    title: "Status",
    dataIndex: "verification_status",
    key: "verification_status",
    render: (value) => renderVerificationStatus(value as VerificationStatusEnum),
  },
];

export const VerificationRequestsPage: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useBasecampClinicListingsRetrieve({
    verification_status: BasecampClinicListingsRetrieveVerificationStatus.PENDING,
  });

  const listings: GetClinicListingsOutput[] =
    data?.status === 200 ? (Array.isArray(data.data) ? data.data : [data.data]) : [];

  return (
    <div className="flex flex-col bg-bg-default min-h-full px-16 py-8">
      <Heading size="medium" className="mb-6">
        Verification requests
      </Heading>

      <Table<GetClinicListingsOutput>
        data={listings}
        loading={isLoading}
        columns={COLUMNS}
        showSearch
        showPagination
        defaultItemsPerPage={10}
        itemsPerPageOptions={[10, 25, 50]}
        onRowClick={(row) => navigate(`/verification-requests/${row.id}`)}
      />
    </div>
  );
};
